import { useEffect, useState, useRef } from "react";
import { api } from "../lib/api";

interface ImageOptions {
    width?: number;
    height?: number;
    quality?: number;
}

interface PlacementData {
    id: number;
    image_id: string;
    section_id: number;
    sort_order: number;
    additional_config: string;
    storage_path: string;
    title: string;
}

interface UseImagePlacementResult {
    imageUrls: string[];
    isLoading: boolean;
    error: string | null;
    placements: PlacementData[];
}

export const useImagePlacement = (
    sectionId: number,
    options?: ImageOptions,
): UseImagePlacementResult => {
    const [imageUrls, setImageUrls] = useState<string[]>([]);
    const [placements, setPlacements] = useState<PlacementData[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const optionsRef = useRef(options);

    useEffect(() => {
        const fetchPlacements = async () => {
            try {
                const data: PlacementData[] = await api.getPlacements(sectionId);

                if (!data || data.length === 0) {
                    setIsLoading(false);
                    return;
                }

                setPlacements(data);

                const urls = data.map((p) =>
                    api.getImageUrl(p.storage_path, {
                        width: optionsRef.current?.width,
                    })
                );
                setImageUrls(urls);
            } catch (err) {
                console.error("画像配置の取得に失敗しました:", err);
                setError("画像配置の取得に失敗しました");
            } finally {
                setIsLoading(false);
            }
        };

        fetchPlacements();
    }, [sectionId]);

    return { imageUrls, isLoading, error, placements };
};
